import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { customSessionStorage } from '@crehana/utils';

// Interface for webview state stored in sessionStorage

// WebView detection result

// Constants
var KEY_WEBVIEW_STATE = 'creh-is-in-web-view';

/**
 * Check if webview query parameter is present
 */
var checkQueryParameter = function checkQueryParameter() {
  var params = new URLSearchParams(window.location.search);
  return params.get('from-webview') === 'true' || params.get('isFromApps') === 'true';
};

/**
 * Detect if application is running inside a WebView using multiple strategies
 */
var detectWebView = function detectWebView() {
  if (typeof window === 'undefined') {
    return {
      isWebView: false
    };
  }
  var storedValue = customSessionStorage.getItem(KEY_WEBVIEW_STATE);
  if (storedValue) {
    var data = JSON.parse(storedValue);

    // Security: Validate origin to prevent cross-origin attacks by ensuring the stored origin matches current origin
    if (data.origin === window.location.origin) {
      return {
        isWebView: data.isWebView
      };
    }

    // Clean expired WebView state from sessionStorage
    customSessionStorage.removeItem(KEY_WEBVIEW_STATE);
    return {
      isWebView: false
    };
  }

  // Check query parameter
  if (checkQueryParameter()) {
    var result = {
      isWebView: true
    };
    if (result.isWebView) {
      var state = {
        isWebView: true,
        origin: window.location.origin
      };
      customSessionStorage.setItem(KEY_WEBVIEW_STATE, JSON.stringify(state));
    }
    return result;
  }
  return {
    isWebView: false
  };
};
var getInitialState = function getInitialState() {
  if (typeof window === 'undefined') {
    return false;
  }
  return detectWebView().isWebView;
};

/**
 * Custom hook to detect if the application is running inside a WebView
 * @returns {boolean} True if running in a WebView, false otherwise
 */
export var useIsRenderedFromWebView = function useIsRenderedFromWebView() {
  var _useState = useState(getInitialState),
    _useState2 = _slicedToArray(_useState, 2),
    isWebView = _useState2[0],
    setIsWebView = _useState2[1];
  useEffect(function () {
    var detection = detectWebView();
    setIsWebView(detection.isWebView);
  }, []);
  return isWebView;
};